import api from './../../Api.js';

function User_helper(props){
		
	this.props = props; 

}

 

User_helper.prototype.userCheckXlsx = async function(course){

	//for (var i = 0; i < this.props.units.length; i++) {//}
	var req = await api.userCheckXlsx(course).then(async (res) => {
    	
    	return {status:200,data:res.data};
       
    }).catch(error => {

      if(error.response && error.response.status === 400){

      	return {status:400,data:error.response};

      }

      console.error('Erro ao verificar XLSX:', error);
      return {status:500,data:{data:{msg: error.message || 'Erro de conexão com o servidor'}}};

    });

	return req;

}

User_helper.prototype.userCheckXlsxUpdate = async function(data) {
	var req = await api.userCheckXlsxUpdate(data).then(async (res) => {
		return { status: 200, data: res.data };
	}).catch(error => {
		if (error.response && error.response.status === 400) {
			return { status: 400, data: error.response };
		}
		console.error('Erro ao verificar XLSX (update):', error);
		return { status: 500, data: { data: { msg: error.message || 'Erro de conexão com o servidor' } } };
	});
	return req;
};

User_helper.prototype.userBulkUpdate = async function(data) {
	var req = await api.userBulkUpdate(data).then(async (res) => {
		return { status: 200, data: res.data };
	}).catch(error => {
		if (error.response && error.response.status === 400) {
			return { status: 400, data: error.response };
		}
		console.error('Erro ao aplicar atualização em massa:', error);
		return { status: 500, data: { data: { msg: error.message || 'Erro de conexão com o servidor' } } };
	});
	return req;
};

export default User_helper;